import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#a4c8ff]/80 backdrop-blur-md shadow-md' : 'bg-[#a4c8ff]/80 backdrop-blur-md'
          }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20 gap-4">
            <div className="flex items-center gap-3 min-w-0">
              <img
                src="https://static.readdy.ai/image/9e24acfcc0bb6a2db26eca4ee1fec42d/fe3070f4f000a088e75b8c338232d497.png"
                alt="ビスケット"
                className="h-12 w-12 rounded-full object-cover"
              />
              <span className="min-w-0 truncate text-xs sm:text-sm font-semibold text-slate-800">
                AIが作ってくれる時代の「つくり方」体験
              </span>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <button
                onClick={() => scrollToSection('overview')}
                className="text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer whitespace-nowrap"
              >
                講座概要
              </button>
              <button
                onClick={() => scrollToSection('benefits')}
                className="text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer whitespace-nowrap"
              >
                得られること
              </button>
              <button
                onClick={() => scrollToSection('flow')}
                className="text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer whitespace-nowrap"
              >
                講座の流れ
              </button>
              <button
                onClick={() => scrollToSection('target')}
                className="text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer whitespace-nowrap"
              >
                こんな方におすすめ
              </button>
              <button
                onClick={() => scrollToSection('testimonials')}
                className="text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer whitespace-nowrap"
              >
                受講者の声
              </button>
              <button
                onClick={() => scrollToSection('schedule')}
                className="text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer whitespace-nowrap"
              >
                開催情報
              </button>
              <button
                onClick={() => scrollToSection('instructor')}
                className="text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer whitespace-nowrap"
              >
                講師
              </button>
              <button
                onClick={() => scrollToSection('apply')}
                className="px-6 py-2.5 bg-[#64a5ff] text-white text-sm font-semibold rounded-full hover:bg-[#5294ee] transition-colors cursor-pointer whitespace-nowrap shadow-sm"
              >
                申し込む
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer"
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-slate-200">
              <div className="px-6 py-4 space-y-3">
                <button
                  onClick={() => scrollToSection('overview')}
                  className="block w-full text-left text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer py-2"
                >
                  講座概要
                </button>
                <button
                  onClick={() => scrollToSection('benefits')}
                  className="block w-full text-left text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer py-2"
                >
                  得られること
                </button>
                <button
                  onClick={() => scrollToSection('flow')}
                  className="block w-full text-left text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer py-2"
                >
                  講座の流れ
                </button>
                <button
                  onClick={() => scrollToSection('target')}
                  className="block w-full text-left text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer py-2"
                >
                  こんな方におすすめ
                </button>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="block w-full text-left text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer py-2"
                >
                  受講者の声
                </button>
                <button
                  onClick={() => scrollToSection('schedule')}
                  className="block w-full text-left text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer py-2"
                >
                  開催情報
                </button>
                <button
                  onClick={() => scrollToSection('instructor')}
                  className="block w-full text-left text-sm font-medium text-slate-700 hover:text-[#64a5ff] transition-colors cursor-pointer py-2"
                >
                  講師
                </button>
                <button
                  onClick={() => scrollToSection('apply')}
                  className="block w-full text-center px-6 py-2.5 bg-[#64a5ff] text-white text-sm font-semibold rounded-full hover:bg-[#5294ee] transition-colors cursor-pointer whitespace-nowrap shadow-sm mt-2"
                >
                  申し込む
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden pt-20" style={{
        backgroundImage: 'url(https://readdy.ai/api/search-image?query=soft%20gentle%20technology%20background%20with%20light%20blue%20cyan%20turquoise%20green%20colors%20featuring%20smooth%20flowing%20abstract%20shapes%20digital%20network%20patterns%20dots%20and%20lines%20creating%20calm%20peaceful%20modern%20IT%20atmosphere%20with%20pastel%20tones%20professional%20clean%20design%20for%20programming%20education%20website%20serene%20technological%20aesthetic&width=1920&height=1080&seq=hero-soft-tech-bg-003&orientation=landscape)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="absolute inset-0 bg-white/60"></div>

        <div className="relative z-10 text-center px-6 max-w-5xl mx-auto py-16">
          <div className="inline-block mb-8 px-6 py-2.5 bg-white/50 rounded-full">
            <span className="text-[#64a5ff] text-base font-medium">プログラミング未経験者・初心者でも安心</span>
          </div>

          <h1 className="font-bold text-slate-800 mb-6 leading-tight">
            <span className="block text-4xl md:text-5xl">AIが作ってくれる時代の「つくり方」体験</span>
            <span className="block mt-3 sm:mt-4 text-3xl md:text-4xl font-medium mb-3 text-slate-600">―コードを書かずに人とAIの違いを考える―</span>
          </h1>

          <div className="mt-12 mb-16 space-y-4">
            <p className="text-lg md:text-xl text-slate-700 leading-relaxed">
              コンピュータがどう動くのか、その素の姿にふれるやさしい体験講座。
            </p>
            <p className="text-lg md:text-xl text-slate-700 leading-relaxed">
              手作りとAIの違いを体験し、"AIとどう付き合うか"が見えてくる。
            </p>
          </div>

          <button
            onClick={() => scrollToSection('apply')}
            className="group inline-flex items-center px-10 py-4 bg-[#64a5ff] text-white text-base font-semibold rounded-full hover:bg-[#5294ee] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            申し込む
            <i className="ri-arrow-right-line ml-3 text-xl group-hover:translate-x-1 transition-transform"></i>
          </button>
        </div>
      </section>

      {/* Overview Section */}
      <section id="overview" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-12 gap-12 items-start">
            <div className="md:col-span-7">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
                講座概要
              </h2>
              <div className="w-20 h-1 bg-[#64a5ff] mb-8 rounded-full"></div>

              <div className="space-y-6 text-slate-700 leading-relaxed">
                <p className="text-base">
                  ビジュアルプログラミングツール「ビスケット」でゲームを作った後、日本語の文として"仕様"に書き起こし、その文章をもとに生成AIにプログラムを作らせます。150分でこのサイクルを体験できるのがこの講座最大の魅力です。
                </p>

                <p className="text-base">
                  「手作りのプログラミング」 と「生成AIによるプログラミング」 の両方を体験し、これからの時代に必要な"ものの見方"をつかむ内容です。
                </p>

                <a
                  href="https://www.viscuit.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-gradient-to-br from-[#a4c8ff]/20 to-[#64a5ff]/20 border-l-4 border-[#64a5ff] p-6 rounded-r-xl hover:from-[#a4c8ff]/30 hover:to-[#64a5ff]/30 transition-all cursor-pointer"
                >
                  <div className="flex items-start gap-4">
                    <img
                      src="https://static.readdy.ai/image/9e24acfcc0bb6a2db26eca4ee1fec42d/fe3070f4f000a088e75b8c338232d497.png"
                      alt="ビスケット"
                      className="w-16 h-16 rounded-xl object-cover flex-shrink-0"
                    />
                    <p className="text-base text-slate-700">
                      ビスケットは子どもが夢中で遊びながら学べるプログラミング言語です。覚えることは驚くほど少なく、自由度は大きく、大人も"つくる楽しさ"に没頭できます。ビスケットは、誰もが最速でプログラミング体験できる道具です。
                    </p>
                  </div>
                </a>
              </div>
            </div>

            <div className="md:col-span-5">
              <div className="bg-gradient-to-br from-[#a4c8ff]/20 to-[#64a5ff]/20 rounded-3xl p-8 text-center shadow-sm h-full flex flex-col justify-between">
                <div className="mb-8">
                  <span className="text-7xl font-black text-[#64a5ff]">150</span>
                  <span className="text-2xl font-bold text-[#64a5ff] ml-2">分</span>
                </div>

                <div className="space-y-6 text-left">
                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#64a5ff] rounded-2xl mr-4 flex-shrink-0">
                      <i className="ri-time-line text-white text-xl"></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-slate-800">短時間で完結</p>
                      <p className="text-xs text-slate-600 mt-1">150分で2種類のプログラミング体験</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#64a5ff] rounded-2xl mr-4 flex-shrink-0">
                      <i className="ri-computer-line text-white text-xl"></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-slate-800">オンライン開催</p>
                      <p className="text-xs text-slate-600 mt-1">自宅から参加可能</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#64a5ff] rounded-2xl mr-4 flex-shrink-0">
                      <i className="ri-lightbulb-line text-white text-xl"></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-slate-800">初心者歓迎</p>
                      <p className="text-xs text-slate-600 mt-1">未経験でも安心</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="benefits" className="py-24 bg-gradient-to-br from-[#a4c8ff]/10 to-[#64a5ff]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 text-center mb-16">
            得られること
          </h2>

          <div className="space-y-2 max-w-5xl mx-auto">
            <div className="flex items-start gap-4 p-6">
              <div className="flex-shrink-0 w-10 h-10 bg-[#64a5ff] rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">1</span>
              </div>
              <p className="text-2xl text-slate-700 leading-[1.25] pt-2">
                「小さなルール」を自分で決めて積み重ねる、手作りのプログラミング体験
              </p>
            </div>

            <div className="flex items-start gap-4 p-6">
              <div className="flex-shrink-0 w-10 h-10 bg-[#64a5ff] rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">2</span>
              </div>
              <p className="text-2xl text-slate-700 leading-[1.25] pt-2">
                プログラミングを通して触れる、"素のコンピュータの性質"
              </p>
            </div>

            <div className="flex items-start gap-4 p-6">
              <div className="flex-shrink-0 w-10 h-10 bg-[#64a5ff] rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">3</span>
              </div>
              <p className="text-2xl text-slate-700 leading-[1.25] pt-2">
                仕様から一瞬でプログラムを生み出すAIの力と、足りない部分を補う仕組み
              </p>
            </div>

            <div className="flex items-start gap-4 p-6">
              <div className="flex-shrink-0 w-10 h-10 bg-[#64a5ff] rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">4</span>
              </div>
              <p className="text-2xl text-slate-700 leading-[1.25] pt-2">
                手作りと生成AI、それぞれの得意分野と境界線の理解
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Flow Section */}
      <section id="flow" className="py-24 bg-gradient-to-b from-white to-[#a4c8ff]/10">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 text-center mb-16">
            講座の流れ・3つの体験
          </h2>

          <div className="space-y-0">
            <div className="relative bg-white border-2 border-[#64a5ff] rounded-2xl shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-start gap-6 p-8">
                <div className="flex-shrink-0 w-14 h-14 bg-[#64a5ff] rounded-2xl flex items-center justify-center text-2xl font-bold text-white">
                  1
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-slate-800 mb-2">
                    短時間でプログラミングを体験
                  </h3>
                  <p className="text-sm text-slate-600">
                    プログラミングに全く触れたことのない人でも大丈夫。世界一簡単なプログラミングツールビスケットを使い、プログラミングによる自由自在な感覚を味わっていただきます。
                  </p>
                </div>
                <div className="hidden md:block w-32 h-20 rounded-lg flex-shrink-0 overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/9e24acfcc0bb6a2db26eca4ee1fec42d/7f8b614afcab8bc042cafc037f66c92a.png"
                    alt="ステップ1"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-center -my-1 relative z-10">
              <div className="w-0 h-0 border-l-[20px] border-l-transparent border-r-[20px] border-r-transparent border-t-[24px] border-t-[#64a5ff]"></div>
            </div>

            <div className="relative bg-white border-2 border-[#64a5ff] rounded-2xl shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-start gap-6 p-8">
                <div className="flex-shrink-0 w-14 h-14 bg-[#64a5ff] rounded-2xl flex items-center justify-center text-2xl font-bold text-white">
                  2
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-slate-800 mb-2">
                    プログラムの仕様を作る体験
                  </h3>
                  <p className="text-sm text-slate-600">
                    作ったビスケットのプログラムを日本語として読む方法をお伝えします。読むだけで、そのプログラムの仕様が出来上がります。
                  </p>
                </div>
                <div className="hidden md:block w-32 h-20 rounded-lg flex-shrink-0 overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/9e24acfcc0bb6a2db26eca4ee1fec42d/10d6013e755cd20725dfb854c6107652.png"
                    alt="ステップ2"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-center -my-1 relative z-10">
              <div className="w-0 h-0 border-l-[20px] border-l-transparent border-r-[20px] border-r-transparent border-t-[24px] border-t-[#64a5ff]"></div>
            </div>

            <div className="relative bg-white border-2 border-[#64a5ff] rounded-2xl shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-start gap-6 p-8">
                <div className="flex-shrink-0 w-14 h-14 bg-[#64a5ff] rounded-2xl flex items-center justify-center text-2xl font-bold text-white">
                  3
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-slate-800 mb-2">
                    AIプログラミングが一段深まる体験
                  </h3>
                  <p className="text-sm text-slate-600">
                    仕様をAIに与えてプログラムを生成させ、元のビスケットのプログラムと比較します。作らせたいもののゴールが明確なため、どこが自分の指示でどこからがAIが補完したのかが感覚的に分かります。
                  </p>
                </div>
                <div className="hidden md:block w-32 h-20 rounded-lg flex-shrink-0 overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/9e24acfcc0bb6a2db26eca4ee1fec42d/4f4ec5a32650873bc40d83d97e177e57.png"
                    alt="ステップ3"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Target Audience Section */}
      <section id="target" className="py-24 bg-gradient-to-br from-[#64a5ff] to-[#5294ee]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16">
            こんな方におすすめ
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6">
                <i className="ri-computer-line text-white text-6xl"></i>
              </div>
              <p className="text-base text-white leading-relaxed">
                パソコンが苦手で、AIやプログラミングには気が引ける
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6">
                <i className="ri-hand-heart-line text-white text-6xl"></i>
              </div>
              <p className="text-base text-white leading-relaxed">
                座学より体験で楽しく学びたい
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6">
                <i className="ri-footprint-line text-white text-6xl"></i>
              </div>
              <p className="text-base text-white leading-relaxed">
                生成AIを使う上で地に足をつけて進めたい
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-24 bg-gradient-to-br from-[#a4c8ff]/20 to-[#64a5ff]/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 text-center mb-16">
            受講者の声
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-md">
              <div className="flex justify-center mb-6">
                <div className="w-16 h-16 bg-[#a4c8ff]/30 rounded-full flex items-center justify-center">
                  <i className="ri-user-line text-[#64a5ff] text-3xl"></i>
                </div>
              </div>
              <p className="text-sm text-slate-700 leading-relaxed mb-4">
                普段AIにコードを書いてもらっていますが、なぜ動くのか良く分からず使用していました。本講座での体験で、AIへの伝え方が感覚的に理解できました。プログラミング初心者はもちろん、AI初心者やなんとなくAIを使っている方にもおすすめです。プログラミングとAIの解像度が上がる講座です。
              </p>
              <p className="text-xs text-slate-500 font-semibold text-center">20代女性・会社員</p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-md">
              <div className="flex justify-center mb-6">
                <div className="w-16 h-16 bg-[#a4c8ff]/30 rounded-full flex items-center justify-center">
                  <i className="ri-user-line text-[#64a5ff] text-3xl"></i>
                </div>
              </div>
              <p className="text-sm text-slate-700 leading-relaxed mb-4">
                ビスケットは子ども向けだと思っていましたが、中身はしっかり"プログラミング"でした。自分の描いた絵が動き出す楽しさに加え、AIによるプログラミングにも触れられる構成で、専門知識がなくても夢中になれました。純粋な好奇心を刺激してくれる講座です。
              </p>
              <p className="text-xs text-slate-500 font-semibold text-center">40代男性・会社員</p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-md">
              <div className="flex justify-center mb-6">
                <div className="w-16 h-16 bg-[#a4c8ff]/30 rounded-full flex items-center justify-center">
                  <i className="ri-user-line text-[#64a5ff] text-3xl"></i>
                </div>
              </div>
              <p className="text-sm text-slate-700 leading-relaxed mb-4">
                プログラミング経験ゼロでしたが、短時間でゲームが作れ、AIにも実装させる体験ができました。自分のイメージが言葉にすれば形になることに感動し、遠い世界だったプログラミングが一気に身近になりました。ITに苦手意識がある同世代にも安心しておすすめできる講座です。
              </p>
              <p className="text-xs text-slate-500 font-semibold text-center">50代女性・会社員</p>
            </div>
          </div>
        </div>
      </section>

      {/* Schedule Section */}
      <section id="schedule" className="py-24 bg-gradient-to-b from-white to-[#a4c8ff]/10">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 text-center mb-16">
            開催情報
          </h2>

          <div className="bg-white rounded-3xl shadow-md border-2 border-[#64a5ff]/50 p-8 md:p-12">
            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-[#64a5ff] rounded-full flex items-center justify-center">
                  <i className="ri-calendar-line text-white text-xl"></i>
                </div>
                <div className="flex-1">
                  <p className="text-xs font-bold text-slate-500 mb-3 uppercase tracking-wider">日時</p>
                  <div className="space-y-2">
                    <p className="text-base text-slate-900">2026年2月14日（土）10:00〜12:30</p>
                    <p className="text-base text-slate-900">2026年2月20日（金）19:00〜21:30</p>
                    <p className="text-base text-slate-900">※今後も月2回程度で定期的に開催します。</p>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-[#64a5ff] rounded-full flex items-center justify-center">
                  <i className="ri-computer-line text-white text-xl"></i>
                </div>
                <div className="flex-1">
                  <p className="text-xs font-bold text-slate-500 mb-3 uppercase tracking-wider">形式</p>
                  <p className="text-base text-slate-900">オンライン（zoom）／150分</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-[#64a5ff] rounded-full flex items-center justify-center">
                  <i className="ri-price-tag-3-line text-white text-xl"></i>
                </div>
                <div className="flex-1">
                  <p className="text-xs font-bold text-slate-500 mb-3 uppercase tracking-wider">参加費</p>
                  <p className="text-base text-slate-900">5,500円（税込）</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-[#64a5ff] rounded-full flex items-center justify-center">
                  <i className="ri-user-line text-white text-xl"></i>
                </div>
                <div className="flex-1">
                  <p className="text-xs font-bold text-slate-500 mb-3 uppercase tracking-wider">対象</p>
                  <p className="text-base text-slate-900">中学生以上〜大人（プログラミング未経験歓迎）</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-[#64a5ff] rounded-full flex items-center justify-center">
                  <i className="ri-device-line text-white text-xl"></i>
                </div>
                <div className="flex-1">
                  <p className="text-xs font-bold text-slate-500 mb-3 uppercase tracking-wider">使用機材</p>
                  <p className="text-base text-slate-900 leading-relaxed">
                    PC（zoom・テキスト入力・生成AI用）、タブレットまたはPC（ビスケット用）
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-[#64a5ff] rounded-full flex items-center justify-center">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div className="flex-1">
                  <p className="text-xs font-bold text-slate-500 mb-3 uppercase tracking-wider">お問い合わせ</p>
                  <p className="text-base text-[#64a5ff]">info@viscuit.com</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-[#64a5ff] rounded-full flex items-center justify-center">
                  <i className="ri-building-line text-white text-xl"></i>
                </div>
                <div className="flex-1">
                  <p className="text-xs font-bold text-slate-500 mb-3 uppercase tracking-wider">運営</p>
                  <a href="https://www.viscuit.com" target="_blank" rel="noopener noreferrer" className="text-base text-[#64a5ff] hover:text-[#5294ee] transition-colors">
                    合同会社デジタルポケット www.viscuit.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <button
              onClick={() => scrollToSection('apply')}
              className="inline-flex items-center px-10 py-4 bg-[#64a5ff] text-white text-base font-semibold rounded-full hover:bg-[#5294ee] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              申し込む
              <i className="ri-arrow-right-line ml-3 text-xl"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Instructor Section */}
      <section id="instructor" className="py-24 bg-gradient-to-b from-[#a4c8ff]/10 to-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-12 gap-12 items-start">
            <div className="md:col-span-3">
              <div className="rounded-2xl overflow-hidden shadow-sm border border-slate-100">
                <img
                  src="https://static.readdy.ai/image/9e24acfcc0bb6a2db26eca4ee1fec42d/c3f6549dc9467b01b88bfade87d4c0e2.jpeg"
                  alt="原田康徳"
                  className="w-full h-auto object-cover object-top"
                  style={{ objectPosition: 'center 15%' }}
                />
              </div>
            </div>

            <div className="md:col-span-9">
              <h2 className="text-2xl font-bold text-slate-800 mb-6">
                原田 康徳
              </h2>

              <p className="text-base text-slate-700 mb-6">
                ビスケット開発者／計算機科学者／博士（工学）／ワークショップデザイナー
              </p>

              <p className="text-base text-slate-700 leading-relaxed mb-6">
                コンピュータサイエンス入門講座を10年以上実施。体験と対話を通じて"本質理解"を伝えることを得意とする。2024年度日本ソフトウェア学会業績賞受賞。
              </p>

              <div className="bg-[#a4c8ff]/20 rounded-2xl p-6 flex items-start border border-[#64a5ff]/30">
                <div className="w-10 h-10 flex items-center justify-center bg-[#64a5ff] rounded-xl mr-4 flex-shrink-0">
                  <i className="ri-book-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-slate-900 mb-1">著書</p>
                  <p className="text-sm text-slate-700">
                    「コンピュータのひみつ −さわるようにしくみがわかる(技術評論社)」
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-24 bg-gradient-to-br from-[#a4c8ff]/10 to-[#64a5ff]/10">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 text-center mb-16">
            よくある質問
          </h2>

          <div className="space-y-6">
            <div className="bg-white rounded-xl p-8">
              <div className="flex items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-[#64a5ff] rounded-full mr-4 flex-shrink-0">
                  <span className="text-white font-bold text-sm">Q</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-base font-bold text-slate-900 mb-3">
                    プログラミング経験がなくても参加できますか?
                  </h3>
                  <div className="border-t border-slate-200 pt-3">
                    <p className="text-sm text-slate-600 leading-relaxed">
                      はい、全く問題ありません。「コードを書かないプログラミング体験」を通じて、自身が意図してプログラミングをすることを目的としています。誰でも理解できる形で進行いたします。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8">
              <div className="flex items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-[#64a5ff] rounded-full mr-4 flex-shrink-0">
                  <span className="text-white font-bold text-sm">Q</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-base font-bold text-slate-900 mb-3">
                    必要な準備や機材はありますか?
                  </h3>
                  <div className="border-t border-slate-200 pt-3">
                    <p className="text-sm text-slate-600 leading-relaxed">
                      パソコン1台でも可能ですが、パソコンとタブレットがおすすめです。パソコン1台の場合はブラウザ上でビスケットを使用します。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8">
              <div className="flex items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-[#64a5ff] rounded-full mr-4 flex-shrink-0">
                  <span className="text-white font-bold text-sm">Q</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-base font-bold text-slate-900 mb-3">
                    講座についていけるか不安です
                  </h3>
                  <div className="border-t border-slate-200 pt-3">
                    <p className="text-sm text-slate-600 leading-relaxed">
                      体験型でゆっくり進むのでご安心ください。この講座は「できる・できない」よりも、触ってみて気づくことを大事にしています。ついていけなくなる心配はほぼありません。わからないことはその場で質問いただけます。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8">
              <div className="flex items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-[#64a5ff] rounded-full mr-4 flex-shrink-0">
                  <span className="text-white font-bold text-sm">Q</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-base font-bold text-slate-900 mb-3">
                    経費や研修費としての支払いはできますか?
                  </h3>
                  <div className="border-t border-slate-200 pt-3">
                    <p className="text-sm text-slate-600 leading-relaxed">
                      はい、可能です。ご希望があれば領収書を発行いたしますので、お申し込み後にお知らせください。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8">
              <div className="flex items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-[#64a5ff] rounded-full mr-4 flex-shrink-0">
                  <span className="text-white font-bold text-sm">Q</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-base font-bold text-slate-900 mb-3">
                    研修として依頼できますか？内容のアレンジは可能でしょうか？
                  </h3>
                  <div className="border-t border-slate-200 pt-3">
                    <p className="text-sm text-slate-600 leading-relaxed">
                      はい、可能です。本講座で実施している内容をベースにアレンジも承ります。「DX」「ロジカルシンキング」「チームビルディング」「基礎スキル（自律学習、AI活用）」などをテーマとした研修についてもご相談ください。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Apply CTA Section */}
      <section id="apply" className="py-24 bg-gradient-to-br from-[#64a5ff] to-[#5294ee]">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-12">
            講座申込
          </h2>

          <div className="mb-12 space-y-3">
            <p className="text-lg text-white/95 leading-relaxed">
              プログラミングは全責任を負う体験、生成AIはやってもらえる体験。
            </p>
            <p className="text-xl text-white font-bold">
              プログラミングが自分ごとになる。
            </p>
          </div>

          <button
            type="button"
            disabled
            className="inline-flex items-center px-12 py-4 bg-slate-100 text-slate-400 text-base font-bold rounded-full shadow-lg cursor-not-allowed whitespace-nowrap"
          >
            申し込む
            <i className="ri-arrow-right-line ml-3 text-xl"></i>
          </button>

          <div className="mt-5 space-y-1">
            {/* <p className="text-2xl font-bold text-orange-300">満員御礼</p> */}
            <p className="text-base text-orange-300">次回、3/8（日）・3/28（土）に対面講座実施決定（都内）</p>
            <a
              href="https://tr.viscuit.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-lg font-semibold text-orange-300 underline decoration-orange-300/80 underline-offset-2 hover:text-orange-200"
            >
              詳しくはこちら
            </a>
          </div>

          <p className="text-sm text-white/80 mt-8 leading-relaxed">
            ※本講座は個人向けとして開講していますが、同内容をベースにした企業・自治体向け研修のご依頼にも対応しております。
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-50 pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 mb-12">
            <div>
              <h3 className="text-sm font-bold text-slate-800 mb-3">お問い合わせ</h3>
              <a href="mailto:info@viscuit.com" className="text-sm text-[#64a5ff] hover:text-[#5294ee] transition-colors">
                info@viscuit.com
              </a>
            </div>

            <div>
              <h3 className="text-sm font-bold text-slate-800 mb-3">運営｜デジタルポケット</h3>
              <a href="https://www.viscuit.com" target="_blank" rel="noopener noreferrer" className="text-sm text-[#64a5ff] hover:text-[#5294ee] transition-colors">
                www.viscuit.com
              </a>
            </div>
          </div>

          <div className="border-t border-slate-200 pt-8">
            <p className="text-xs text-slate-500 text-center">
              ©️2026 合同会社デジタルポケット
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
